module.exports = __webpack_public_path__ + "static/media/asurion-protect-it-desktop.d03cfac9.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/asurion-protect-it-desktop.jpg
// module id = 1387
// module chunks = 0